/** Enumeration of application error codes. */
export const ErrorCode = {
  SESSION_NOT_FOUND: 'SESSION_NOT_FOUND',
  INVALID_PARAM: 'INVALID_PARAM',
  INTERNAL: 'INTERNAL',
} as const;

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];

/** Structured application error with HTTP status code and machine-readable code. */
export class AppError extends Error {
  constructor(
    public readonly code: ErrorCode,
    public readonly statusCode: number,
    message: string,
  ) {
    super(message);
    this.name = 'AppError';
  }
}

/** 404 — resource not found. */
export function notFound(resource: string, id: string): AppError {
  return new AppError(
    ErrorCode.SESSION_NOT_FOUND,
    404,
    `${resource} '${id}' not found`,
  );
}

/** 400 — bad request / invalid parameter. */
export function badRequest(message: string): AppError {
  return new AppError(ErrorCode.INVALID_PARAM, 400, message);
}

/** 500 — internal server error. */
export function internal(message: string): AppError {
  return new AppError(ErrorCode.INTERNAL, 500, message);
}
